module.exports = __webpack_public_path__ + "img/states-icon-es.f2454088.jpg";